module.exports = __webpack_public_path__ + "static/media/Asset 45.e9519a0c.png";